import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { images } from '../_shared/data/image';
import { FeaturedEventsService } from '../_core/services/featured-events.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { ThemeService } from '../_core/services/theme.service';
import { NavController } from '@ionic/angular';
import { FeaturedEvent } from '../_shared/models/featured-event.model';

@Component({
  standalone: false,
  selector: 'app-featured-events',
  templateUrl: './featured-events.component.html',
  styleUrls: ['./featured-events.component.scss'],
})
export class FeaturedEventsComponent implements OnInit, OnDestroy {
  themeService = inject(ThemeService);
  private navCtrl = inject(NavController);
  private readonly featuredEventsService = inject(FeaturedEventsService);
  private readonly destroy$ = new Subject<void>();

  public readonly italogo = images.italogo;
  public readonly pickleballIcon = images.pickleball;
  public readonly intennseAd = images.intennseAd;
  public readonly mlp = images.mlp;
  public featuredEventsList: FeaturedEvent[] = [];
  public isLoading = false;

  constructor() { }

  ngOnInit() {
    this.getAllFeaturedEvents();
  }

  getAllFeaturedEvents() {
    this.isLoading = true;

    this.featuredEventsService.getAllFeaturedEvents()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (response) => {
          this.featuredEventsList = response || [];
        },
        error: (error) => {
          console.error('Error fetching featured events:', error);
          this.featuredEventsList = [];
        }
      });
  }

  navigateToEventPage(url: string, linkType: string) {
    if (!url) return;
    if (linkType === 'internal') {
      this.navCtrl.navigateForward(url);
    } else {
      // For external URLs
      window.open(url, '_blank');
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
